import { get } from 'lodash/fp';

import * as fromReducer from './reducer';

const getCountiesFromReducer = get('territories.counties');

export const getIsLoading = state => fromReducer.getIsLoading(getCountiesFromReducer(state));

export const getCounties = state => fromReducer.getCounties(getCountiesFromReducer(state));
